const COMPONENT_NAME = "mobile-scroller";
const CLASS_SELECTOR = ".MobileScroller";
const INNER_SELECTOR = ".MobileScroller-inner";

const instances = [];
let initialized = false;
let lastAnimationFrame = 0;

function update(element) {
    if (!element) return;
    const inner = element.querySelector(INNER_SELECTOR);
    let fadeLeft = false;
    let fadeRight = false;
    if (inner.offsetWidth < inner.scrollWidth) {
        fadeLeft = (inner.scrollLeft >= 1);
        fadeRight = (inner.scrollLeft < (inner.scrollWidth - inner.offsetWidth - 1));
    }
    element.classList.toggle('is-fadedLeft', fadeLeft);
    element.classList.toggle('is-fadedRight', fadeRight);
}

function resizeHandler() {
    requestAnimationFrame((timestamp) => {
        if (timestamp > lastAnimationFrame) {
            lastAnimationFrame = timestamp;
            instances.forEach((element, index) => {
                update(element);
            });
        }
    });
}

function scrollHandler(element) {
    requestAnimationFrame((timestamp) => {
        update(element);
    });
}

function initialize(element, PageComponents) {
    element.querySelector(INNER_SELECTOR).addEventListener(
        'scroll',
        () => {
            scrollHandler(element);
        }
    );
    instances.push(element);

    if (!initialized) {
        window.addEventListener('resize', resizeHandler);
        initialized = true;
    }
}

module.exports = {
    name: COMPONENT_NAME,

    instances,
    initialize
};
